import Router from "@/router/index";
import VueCookies from 'vue-cookies';

export default Router.beforeEach((to, from, next) => {
    const school_name = VueCookies.get('tenant_school_name') || 'GenEx';
    document.title = `${to.meta.title} | ${school_name}`;
    next();
});
